
	var ProximityComparator = function( col, proxy ){
		this.col = col;
		this.proxy = proxy;
	};
	ProximityComparator.prototype.compare = function( a, b ){
		var da = this.proxy.distanceBetween( this.col, a );
		var db = this.proxy.distanceBetween( this.col, b );
		return da < db ? -1 : da > db ? 1 : 0;
	};
	module.exports = ProximityComparator;



//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/color/ProximityComparator.js
// module id = 3071
// module chunks = 15